import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { LocationModel } from 'projects/core/src/lib/models/location.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-location-new',
  templateUrl: './location-new.component.html',
  styleUrls: ['./location-new.component.scss']
})
export class LocationNewComponent extends BaseForm implements OnInit {

  public country: string | null = null;
  public timezone: string | null = null;

  public form = this.fb.group({
    name: new UntypedFormControl('', [Validators.required]),
    tz: this.fb.group({})
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    if (this.auth.checkRightOrRedirect('admin.location.create')) {
      this.ui.setFormFocus();
    }
  }

  onCancel(): void {
    this.router.navigate(['/locations']);
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      const payload = {
        name: this.form.get('name').value,
        country: this.country,
        timezone: this.timezone
      };
      this.api.saveModel('locations', null, payload).subscribe({
        next: (result: any) => {
          const location = new LocationModel().deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: location.name }), this.transloco.translate('common.saved'));
          this.router.navigate(['/locations', location.id]);
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  private minMaxValidator(group: UntypedFormGroup): any {
    return (group.get('max_value')?.value > group.get('min_value')?.value) ? null : { minMax: true };
  }

}
